import React from "react";

import Box from "grommet/components/Box";
import Heading from "grommet/components/Heading";

import Total from "./total";
import Legend from "./legend";
import { translate } from "react-i18next";
import AppSettings from "../../utils/appSettings";
import Label from "grommet/components/Label";
import Value from "grommet/components/Value";
import currencyFormatter from "currency-formatter";

const ViewerSimple = ({ t, stretch, i18n, series, baseCalcul, computationAppName }) => {
  let sum = 0;
  series.forEach(s => (sum += s.value));

  return (
    <Box align="center" pad={{ between: "large" }} alignSelf="stretch">
      {computationAppName ? (
        <Box margin="large">
          <Heading tag="h2">{computationAppName}</Heading>
        </Box>
      ) : null}
      <Box
          margin={{ vertical: "small" }}
          pad={{ between: "medium" }}
          responsive={true}
          direction="row"
          justify="between"
          align="center"
          flex={true}
        >
          <Heading tag="h2" style={{marginBottom: 0}}>
            {t("Total")}:
          </Heading>
          <Value
            value={currencyFormatter.format(
              sum,
              AppSettings.currencyOptionFormater
            )}
            units="€"
            size="medium"
          />
        </Box>

      <Box alignSelf={stretch ? "stretch" : "center"}>
        {baseCalcul !== undefined ? (
          <Box
            margin={{ vertical: "small" }}
            padding={{ horizontal: "medium" }}
            responsive={true}
            direction="row"
            justify="between"
            align="center"
            flex={true}
          >
            <Label size="medium" strong style={{ margin: 0 }}>
              {t("Base de calcul")}:
            </Label>
            <Value
              value={currencyFormatter.format(
                baseCalcul,
                AppSettings.currencyOptionFormater
              )}
              units="€"
              size="small"
            />
          </Box>
        ) : (
          undefined
        )}
        <Box alignSelf={stretch ? "stretch" : "center"}>
          {series.filter(s => !s.tva).length > 0 ? (
            <Box margin={{ vertical: "small" }}>
              <Heading strong={true} tag="h4" truncate={false} uppercase={true}>
                Debours
              </Heading>
              <Legend
                i18n={i18n}
                series={series.filter(s => !s.tva)}
                units="€"
                total={true}
              />
            </Box>
          ) : null}
          <Box margin={{ vertical: "small" }}>
            {series.filter(s => s.tva).length > 0 ? (
              <React.Fragment>
                <Heading
                  strong={true}
                  tag="h4"
                  truncate={false}
                  uppercase={true}
                >
                  Facture
                </Heading>
                <Legend
                  i18n={i18n}
                  series={series.filter(s => s.tva)}
                  units="€"
                  labelTotal="Total (avec TVA)"
                  total={true}
                />
              </React.Fragment>
            ) : null}

            <Total total={sum} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default translate()(ViewerSimple);



// WEBPACK FOOTER //
// ./src/computationApps/components/viewer/ViewerSimple.js